export function setupTexturePicker() {
    const texturePicker = document.getElementById('texturePicker');
    const uploadContainer = document.querySelector('.upload-container');

    this.sampleDecals.forEach(decal => {
        const newDecal = document.createElement('img');
        newDecal.src = decal.url;
        newDecal.dataset.decalSrc = decal.url;
        newDecal.title = decal.name;
        newDecal.addEventListener('click', (event) => {
            this.setActiveDecal(event.target);
        });
        texturePicker.insertBefore(newDecal, uploadContainer);
    });

    const decals = texturePicker.getElementsByTagName('img');
    if (decals.length > 0) {
        this.setActiveDecal(decals[0]);
    }

    const addDecalButton = document.getElementById('addDecalButton');
    const uploadTooltip = document.getElementById('uploadTooltip');

    if (addDecalButton) {
        addDecalButton.addEventListener('click', () => {
            const input = document.getElementById('decalInput');
            if (input) input.click();
            if (uploadTooltip) uploadTooltip.style.display = 'none';
        });
    }
}

export function setActiveDecal(decalElement) {
    const texturePicker = document.getElementById('texturePicker');
    const decals = texturePicker.getElementsByTagName('img');
    for (const d of decals) d.classList.remove('active');
    decalElement.classList.add('active');
    this.loadDecalTexture(decalElement.dataset.decalSrc);
}

export function addDecalToPicker(url) {
    const texturePicker = document.getElementById('texturePicker');
    const uploadContainer = document.querySelector('.upload-container');
    const newDecal = document.createElement('img');
    newDecal.src = url;
    newDecal.dataset.decalSrc = url;
    newDecal.addEventListener('click', (event) => {
        this.setActiveDecal(event.target);
    });

    texturePicker.insertBefore(newDecal, uploadContainer);
    this.setActiveDecal(newDecal);
}

export function updateModeButtons(activeMode) {
    const compactMode2DBtn = document.getElementById('compactMode2D');
    const compactMode3DBtn = document.getElementById('compactMode3D');
    const compactModeBrushBtn = document.getElementById('compactModeBrush');

    const compactUsage2D = document.getElementById('compactUsage2D');
    const compactUsage3D = document.getElementById('compactUsage3D');
    const compactUsageBrush = document.getElementById('compactUsageBrush');

    const controls2D = document.getElementById('projection2DControls');
    const toolbar = document.querySelector('.viewport-toolbar');
    const applyBtn = document.getElementById('applyDecal');

    if (compactMode2DBtn) compactMode2DBtn.classList.toggle('active', activeMode === '2d');
    if (compactMode3DBtn) compactMode3DBtn.classList.toggle('active', activeMode === '3d');
    if (compactModeBrushBtn) compactModeBrushBtn.classList.toggle('active', activeMode === 'brush');

    if (activeMode === '2d') {
        if (controls2D) controls2D.style.display = 'block';
        if (applyBtn) applyBtn.textContent = 'Apply Decal';
        if (compactUsage2D) compactUsage2D.style.display = 'block';
        if (compactUsage3D) compactUsage3D.style.display = 'none';
        if (compactUsageBrush) compactUsageBrush.style.display = 'none';
        if (toolbar) {
            toolbar.classList.remove('disabled');
            toolbar.setAttribute('aria-disabled', 'false');
        }
    } else if (activeMode === '3d') {
        if (controls2D) controls2D.style.display = 'block';
        if (applyBtn) applyBtn.textContent = 'Apply Decal';
        if (compactUsage2D) compactUsage2D.style.display = 'none';
        if (compactUsage3D) compactUsage3D.style.display = 'block';
        if (compactUsageBrush) compactUsageBrush.style.display = 'none';
        if (toolbar) {
            toolbar.classList.remove('disabled');
            toolbar.setAttribute('aria-disabled', 'false');
        }
    } else if (activeMode === 'brush') {
        if (controls2D) controls2D.style.display = 'none';
        if (compactUsage2D) compactUsage2D.style.display = 'none';
        if (compactUsage3D) compactUsage3D.style.display = 'none';
        if (compactUsageBrush) compactUsageBrush.style.display = 'block';
        if (toolbar) {
            toolbar.classList.add('disabled');
            toolbar.setAttribute('aria-disabled', 'true');
        }
    }

    if (this.brushUI) this.brushUI.updateUIVisibility?.();
}

export function updateStatus(message) {
    const el = document.getElementById('status');
    if (el) el.textContent = message;
}

export function onKeyDown(event) {
    if (window.hotkeysPaused) return;

    const modes = { w: 'translate', e: 'rotate', r: 'scale' };
    if (modes[event.key] && this.transformControls) {
        const newMode = modes[event.key];
        this.transformControls.setMode(newMode);
        // Reflect active mode in UI buttons
        try {
            const translateBtn = document.getElementById('translateMode');
            const rotateBtn = document.getElementById('rotateMode');
            const scaleBtn = document.getElementById('scaleMode');
            if (translateBtn && rotateBtn && scaleBtn) {
                translateBtn.classList.toggle('active', newMode === 'translate');
                rotateBtn.classList.toggle('active', newMode === 'rotate');
                scaleBtn.classList.toggle('active', newMode === 'scale');
            }
        } catch {
            // ignore if toolbar not present
        }
        this.updateStatus(newMode[0].toUpperCase() + newMode.slice(1) + ' mode activated');
    }

    if (event.key === '1') {
        this.setProjectionMode('2d');
        const mode2DBtn = document.getElementById('compactMode2D');
        if (mode2DBtn) mode2DBtn.dispatchEvent(new Event('click'));
    } else if (event.key === '2') {
        this.setProjectionMode('3d');
        const mode3DBtn = document.getElementById('compactMode3D');
        if (mode3DBtn) mode3DBtn.dispatchEvent(new Event('click'));
    } else if (event.key === '3') {
        this.setProjectionMode('brush');
        const modeBrushBtn = document.getElementById('compactModeBrush');
        if (modeBrushBtn) modeBrushBtn.dispatchEvent(new Event('click'));
    }
    if (event.key === 'Escape') {
        if (this.projectionMode === '2d') this.cancelMoveableDecal();
        else if (this.projectionMode === '3d') this.cancel3DProjection();
    }
    if (event.key === 'Enter') {
        if (this.projectionMode === '2d') this.applyMoveableDecal();
        else if (this.projectionMode === '3d') this.apply3DProjection();
    }
}

export function onWindowResize() {
    if (!this.camera || !this.renderer) return;
    const container = document.getElementById('viewport');
    if (!container) return;
    const width = container.clientWidth;
    const height = container.clientHeight;
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(width, height);
    this.render();
}
